import { z } from 'zod'

/** Variáveis públicas (VITE_*) — embutidas no bundle do browser. */
export const publicEnvSchema = z.object({
  VITE_SUPABASE_URL: z.string().url('VITE_SUPABASE_URL deve ser uma URL válida'),
  VITE_SUPABASE_ANON_KEY: z.string().min(1, 'VITE_SUPABASE_ANON_KEY é obrigatória'),
  VITE_ALLOW_SELF_SIGNUP: z
    .string()
    .optional()
    .transform(v => v === 'true'),
  VITE_API_BASE_URL: z.string().optional(),
})

/** Variáveis de servidor — lidas por server/ e scripts Node. */
export const serverEnvSchema = z.object({
  SUPABASE_SERVICE_ROLE: z.string().min(1, 'SUPABASE_SERVICE_ROLE é obrigatória no servidor'),
  APP_URL: z.string().url().default('http://localhost:3050'),
  WHATSAPP_GRAPH_API_VERSION: z.string().default('v21.0'),
  API_PORT: z.coerce.number().default(3051),
  SUPABASE_ACCESS_TOKEN: z.string().optional(),
  SUPABASE_PROJECT_REF: z.string().optional(),
})

/** Variáveis de scripts e testes — lidas só por Node (scripts/, tests/). */
export const scriptsEnvSchema = z.object({
  SEED_DEMO_SENHA: z.string().optional(),
  TEST_MEDICO_EMAIL: z.string().email().optional(),
  TEST_MEDICO_SENHA: z.string().optional(),
  TEST_SECRETARIA_EMAIL: z.string().email().optional(),
  TEST_SECRETARIA_SENHA: z.string().optional(),
  TEST_SECRETARIA_CLINICA_EMAIL: z.string().email().optional(),
  TEST_SECRETARIA_CLINICA_SENHA: z.string().optional(),
  PLATFORM_ADMIN_EMAIL: z.string().email().optional(),
  PLATFORM_ADMIN_SENHA: z.string().optional(),
  TEST_PLATFORM_ADMIN_EMAIL: z.string().email().optional(),
  TEST_PLATFORM_ADMIN_SENHA: z.string().optional(),
})

export type PublicEnv = z.infer<typeof publicEnvSchema>
export type ServerEnv = z.infer<typeof serverEnvSchema>
export type ScriptsEnv = z.infer<typeof scriptsEnvSchema>
